import React from "react";
import "../../Styles/yellowcalf.css/Failed_Wallet_Recharge.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlassPlus } from "@fortawesome/free-solid-svg-icons";

function FailedWallets() {
  return (
    <div className="fw-container" style={{ paddingTop: "25px" }}>
      {/* Main title panel */}
      <div className="fw-main-panel">
        <h3 className="fw-panel-title">Failed Wallets</h3>
      </div>

      {/* Filters + table panel */}
      <div className="fw-panel fw-secondary-panel">
        <div className="fw-filters">
          <select className="fw-input">
            <option>All Students</option>
            <option>John Doe</option>
            <option>Jane Smith</option>
          </select>

          <input type="text" className="fw-input" placeholder="Start date / search" />
          <input type="text" className="fw-input" placeholder="End date / search" />

          <button className="fw-clear-btn">Clear</button>
        </div>

        <div className="fw-table-wrapper">
          <table className="fw-table">
            <thead>
              <tr>
                <th>Sr.NO</th>
                <th>Student</th>
                <th>Amount</th>
                <th>Date Time</th>
                <th>Recharge ID</th>
                <th>Reference No</th>
                <th>Recharge Mode</th>
                <th>Operator</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>1</td>
                <td>John Doe</td>
                <td>₹500</td>
                <td>2025-09-24 14:30</td>
                <td>RCG12345</td>
                <td>REF998877</td>
                <td>Online</td>
                <td>Paytm</td>
                <td>Failed</td>
                <td>
                  <a
                    href="/accountant/failedtransaction/rechargeview?id=492"
                    className="fw-view-btn"
                    title="View"
                  >
                    <i class="bi bi-eye"></i>
                  </a>
                </td>
              </tr>

              <tr>
                <td>2</td>
                <td>Jane Smith</td>
                <td>₹1000</td>
                <td>2025-09-23 12:00</td>
                <td>RCG12346</td>
                <td>REF998878</td>
                <td>PayFort</td>
                <td>Paytm</td>
                <td>Failed</td>
                <td>
                  <a
                    href="/accountant/failedtransaction/rechargeview?id=493"
                    className="fw-view-btn"
                    title="View"
                  >
                    <i class="bi bi-eye"></i>
                  </a>
                </td>
              </tr>

              <tr>
                <td>2</td>
                <td>Jane Smith</td>
                <td>₹1000</td>
                <td>2025-09-23 12:00</td>
                <td>RCG12346</td>
                <td>REF998878</td>
                <td>PayFort</td>
                <td>Paytm</td>
                <td>Failed</td>
                <td>
                  <a
                    href="/accountant/failedtransaction/rechargeview?id=493"
                    className="fw-view-btn"
                    title="View"
                  >
                    <i class="bi bi-eye"></i>
                  </a>
                </td>
              </tr>

              <tr>
                <td>2</td>
                <td>Jane Smith</td>
                <td>₹1000</td>
                <td>2025-09-23 12:00</td>
                <td>RCG12346</td>
                <td>REF998878</td>
                <td>PayFort</td>
                <td>Paytm</td>
                <td>Failed</td>
                <td>
                  <a
                    href="/accountant/failedtransaction/rechargeview?id=493"
                    className="fw-view-btn"
                    title="View"
                  >
                    <i class="bi bi-eye"></i>
                  </a>
                </td>
              </tr>

              <tr>
                <td>2</td>
                <td>Jane Smith</td>
                <td>₹1000</td>
                <td>2025-09-23 12:00</td>
                <td>RCG12346</td>
                <td>REF998878</td>
                <td>PayFort</td>
                <td>Paytm</td>
                <td>Failed</td>
                <td>
                  <a
                    href="/accountant/failedtransaction/rechargeview?id=493"
                    className="fw-view-btn"
                    title="View"
                  >
                    <i class="bi bi-eye"></i>
                  </a>
                </td>
              </tr>

            </tbody>
          </table>
          <div className="wallet-main-footer">
              <ul className="wallet-main-pagination">
                <li className="wallet-main-active">
                  <a href="#">1</a>
                </li>
                <li>
                  <a href="#">2</a>
                </li>
                <li>
                  <a href="#">3</a>
                </li>
              </ul>

              <div className="wallet-main-summary">
                Showing <b>1-50</b> of <b>177</b> items.
              </div>
            </div>
        </div>
      </div>
    </div>
  );
}

export default FailedWallets;
